/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import {
  InboundTaskItemAssignType,
  InboundTaskItemStatusEnum,
} from 'commons/enums';
import { IInboundTaskDocument, InboundTaskDocumentState } from 'commons/types';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';
import { InboundTaskItemAssignUnassignRequest } from 'services/apis/SwipeRxWmsApiInboundTaskItem/type';

const initialState: InboundTaskDocumentState = {
  searchedQueueDocument: null,
};

const inboundTaskDocumentSlice = createSlice({
  name: ReducerKeys.InboundTaskDocument,
  initialState,
  reducers: {
    setSearchedQueueDocument(
      state: InboundTaskDocumentState,
      action: { type: string; payload: IInboundTaskDocument | null },
    ) {
      state.searchedQueueDocument = action.payload;
    },
    setInboundTaskItemAssignStatus(
      state: InboundTaskDocumentState,
      action: {
        type: string;
        payload: {
          assignPayload: InboundTaskItemAssignUnassignRequest;
          assignType: InboundTaskItemAssignType;
          username: string;
        };
      },
    ) {
      const { assignPayload, assignType, username } = action.payload;
      if (
        state.searchedQueueDocument &&
        state.searchedQueueDocument.items &&
        state.searchedQueueDocument.inbound_task_number ===
          assignPayload.inbound_task_number
      ) {
        state.searchedQueueDocument.items =
          state.searchedQueueDocument.items.map((item) => {
            if (
              item.sku_code === assignPayload.sku_code &&
              item.foc === assignPayload.foc
            ) {
              return {
                ...item,
                receiver:
                  assignType === InboundTaskItemAssignType.ASSIGN
                    ? username
                    : null,
                status:
                  assignType === InboundTaskItemAssignType.ASSIGN
                    ? InboundTaskItemStatusEnum.ASSIGNED
                    : InboundTaskItemStatusEnum.QUEUE,
              };
            }
            return item;
          });
      }
    },
  },
});

export const { setSearchedQueueDocument, setInboundTaskItemAssignStatus } =
  inboundTaskDocumentSlice.actions;

export default inboundTaskDocumentSlice.reducer;
